import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { woolPantsPhotos, woolPantsColors } from '../data/woolPants';
export function WoolCollection() {
  return <section id="wool-collection" className="py-24 bg-brand-cream text-brand-dark overflow-hidden" data-id="element-330" data-mp="33h7377cmosld">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-331" data-mp="38huqbhxqkpab">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center" data-id="element-332" data-mp="3dg4o80aui3zm">
          {/* Photos */}
          <div className="order-2 lg:order-1 lg:col-span-8 grid grid-cols-2 md:grid-cols-3 gap-4" data-id="element-333" data-mp="3iefvq4do42eo">
            {woolPantsPhotos.map(photo => <div key={photo.src} className="aspect-[3/4] overflow-hidden rounded-2xl bg-brand-beige" data-id="element-334" data-mp="3n6hgkeowj1gb">
                <img src={photo.src} alt={photo.alt} loading="lazy" className="w-full h-full object-cover photo-grade" data-id="element-335" data-mp="1i2egbds7th" />
              </div>)}
          </div>

          {/* Text */}
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="order-1 lg:order-2 lg:col-span-4" data-id="element-336" data-mp="5kfqlmz0ozzw">
            <p className="text-sm text-brand-burgundy mb-4" data-id="element-337" data-mp="taa2o2biikj3">
              Нова колекція · Осінь — Зима
            </p>
            <h2 className="text-5xl md:text-6xl font-serif leading-tight mb-6" data-id="element-338" data-mp="p981hfy1byeh">
              Шерсть
            </h2>
            <p className="text-brand-dark/70 text-lg leading-relaxed mb-8" data-id="element-339" data-mp="kfvpq6egfm35">
              Теплі штани палаццо з шерстяної тканини: висока посадка, стрілки та
              прямий широкий крій, що витягує силует. Поєднуйте з сорочкою,
              светром чи поло — від офісу до вихідних.
            </p>

            <dl className="mb-10 space-y-4 border-t border-brand-beige pt-6" data-id="element-340" data-mp="185gcl0dqb3hp">
              <div className="flex items-baseline justify-between gap-4" data-id="element-341" data-mp="1r4b2nhwvt4xr">
                <dt className="text-sm text-brand-dark/60" data-id="element-342" data-mp="1w2w39ig1pqmq">Ціна</dt>
                <dd className="text-2xl font-serif text-brand-burgundy" data-id="element-343" data-mp="1w4771i9hqydu">
                  ₴1350
                </dd>
              </div>
              <div className="flex items-baseline justify-between gap-4" data-id="element-344" data-mp="1mbroaiqde5rw">
                <dt className="text-sm text-brand-dark/60" data-id="element-345" data-mp="18cs0fdaoluws">Розміри</dt>
                <dd className="font-medium" data-id="element-346" data-mp="18bgzdl8mf19d">XS — XXL</dd>
              </div>
              <div data-id="element-347" data-mp="1dco3997n7gar">
                <dt className="text-sm text-brand-dark/60 mb-2" data-id="element-348" data-mp="1dd6at1zr9gxz">Кольори</dt>
                <dd className="flex flex-wrap gap-2" data-id="element-349" data-mp="zdez57wpocn5">
                  {woolPantsColors.map(color => <span key={color} className="text-sm px-3 py-1 rounded-full bg-white text-brand-dark/80" data-id="element-350" data-mp="13e7963deqlkh">
                      {color}
                    </span>)}
                </dd>
              </div>
            </dl>

            <a href="#catalog" className="inline-flex items-center gap-2 bg-brand-dark text-brand-cream px-7 py-3.5 rounded-full font-medium hover:bg-brand-dark/90 transition-colors" data-id="element-351" data-mp="m4mlpuri6xat">
              Дивитися в каталозі
              <ArrowRight className="w-4 h-4" data-id="element-352" data-mp="r37kdpr3x8x5" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}